import classNames from 'classnames'

import { Button, Divider, CustomField, Modal } from '@/shared'
import { type ICategoryDto } from '@App/types/servicesTypes'

import style from './AddSectionModal.module.scss'
import { useFields } from './useFields'

interface IAction {
    title: 'Добавить' | 'Отменить'
    color: 'blue' | 'red'
    disabled: boolean
    callback: () => void
}

interface IProps {
    show: boolean
    onClose: () => void
    onAddSection: (dto: ICategoryDto, onSuccess: () => void) => void
    parentId: string | null
}

export const AddSectionModal = (props: IProps) => {
    const { show, onClose, onAddSection, parentId } = props

    const { name, nameError, isValidFields, onChangeName, onInitializeFields, onTouchName, onZeroName } = useFields()

    const onCancelAdditionCallback = () => {
        onInitializeFields()
        onClose()
    }

    const onAddSectionCallback = () => {
        const dto: ICategoryDto = {
            name: name.value,
            isBarsFiltering: true,
            parentId,
            preparingDescription: null,
            permissionRules: [],
            exceptionRules: []
        }
        onAddSection(dto, onCancelAdditionCallback)
        // onClose()
    }

    const actions: IAction[] = [
        { title: 'Добавить', color: 'blue', disabled: isValidFields, callback: onAddSectionCallback },
        { title: 'Отменить', color: 'red', disabled: false, callback: onCancelAdditionCallback }
    ]

    return (
        <Modal show={show} onClose={onCancelAdditionCallback}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Добавить Раздел</span>
                </div>
                <div className={style.fields}>
                    <CustomField
                        value={name.value}
                        placeholder={name.placeholder}
                        name={name.name}
                        onChange={onChangeName}
                        onFocus={onTouchName}
                        onZeroText={onZeroName}
                        error={nameError}
                    />
                </div>
                <Divider />
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, color, disabled, callback } = action
                        return (
                            <Button
                                key={title}
                                className={classNames(style.btn, style[color])}
                                onClick={callback}
                                disabled={disabled}
                            >
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
